import {type UISidebarController} from '../../../ui_html/sidebar/UISidebarController.ts'

export class UIDCommunitySceneController {
    private readonly sidebarController: UISidebarController
    private readonly communitySceneContainerDiv: HTMLDivElement

    constructor(sidebarController: UISidebarController) {
        this.sidebarController = sidebarController
        this.communitySceneContainerDiv = document.getElementById('scene_discord_community_container') as HTMLDivElement
    }

    hide() {
        this.communitySceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.communitySceneContainerDiv.classList.remove('hidden')
        this.sidebarController.deactivateAllButtons()
    }
}
